<div class="status-indicator-cell">
  <xpo-status-indicator
    [statusText]="statusText"
    [statusColor]="statusColor"
    [isLabel]="isLabel"
  ></xpo-status-indicator>
</div>
